<div class="row g-2">
  <div class="col-3">
    <label for="description"
      >Description
      <i class="info-icon ms-2" certTooltip="A brief description of the professional development that took place."></i>
    </label>
    <input
      type="text"
      id="description"
      class="form-control"
      placeholder="e.g. Online Teaching Course"
      [(ngModel)]="command.description"
      name="description"
    />
  </div>
  <div class="col-1">
    <label for="hours"
      >Hours
      <i class="info-icon ms-2" certTooltip="The amount of hours to award."></i>
    </label>
    <input type="text" id="hours" class="form-control" placeholder="e.g. 6" [(ngModel)]="command.hours" name="hours" />
  </div>
  <div class="col-auto">
    <label for="completionDate"
      >Completion Date
      <i class="info-icon ms-2" certTooltip="The date on which the professional development was completed."></i>
    </label>
    <cert-date-input name="completionDate" [(model)]="command.completionDate" [propertyName]="'completionDate'" />
  </div>
  <div class="col-auto">
    <label for="professionalDevelopmentTypeCodeId"
      >Professional Development Type
      <i class="info-icon ms-2" certTooltip="The type of professional development being awarded."></i>
    </label>
    <ng-select
      id="professionalDevelopmentTypeCodeId"
      name="professionalDevelopmentTypeCodeId"
      [closeOnSelect]="true"
      [multiple]="false"
      [(ngModel)]="command.professionalDevelopmentTypeCodeId"
      placeholder="Select a type..."
    >
      @for (option of professionalDevelopmentTypeOptions; track $index) {
        <ng-option [value]="option.id">{{ option.description }}</ng-option>
      }
    </ng-select>
  </div>
  <div class="col-2 d-flex align-items-center">
    <span class="d-inline-block" [certTooltip]="disabledTooltip" [enableTooltip]="disabled">
      <button class="btn btn-primary" [disabled]="disabled" (click)="onSubmit()">Award PD Hours</button>
    </span>
  </div>
</div>
